<template>
  <div class="container-fluid container-style p-0">
    <!-- Slides -->
        <div class="div-title">
          <span class="title-style">{{title}}</span>
          <img class="img-style" :src="require('@/assets/svg/' + img)" alt="">
        </div>
        <vueper-slides ref="mainShop" class="slider no-shadow flex-grow-1 mb-0" 
          v-if="products && products.length"
          :bullets="false" 
          :arrows="true" 
          :touchable="false" 
          :visibleSlides="1" 
          :disableArrowsOnEdges="true" 
          :lazy="true" 
          fixed-height="300px"
          :autoplay="autoplayState"
          >        
            <vueper-slide v-for="(productInfo, index) in products" :key="index" :link="getFullUrl(index)">
                <template v-slot:content>
                  <div class="tile">
                    <img class="tile-img cursor-pointer"
                         :src="url + productInfo.photos[0]"
                         @error="$event.target.src = fallbackImage"
                         alt="">
                    <div class="tile-gradient"></div>
                    <div class="tile-meta">
                      <div class="meta-left">
                        <span class="meta-title">{{ productInfo?.name || '' }}</span>
                      </div>
                      <div class="meta-right">
                        <span class="cta">{{ $t('viewProduct') }}</span>
                      </div>
                    </div>
                  </div>
                </template>
            </vueper-slide>
        </vueper-slides>
      <!-- End Slides -->
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import { mapActions } from "vuex";

const INFLATE = "InflateYourImagination";
const INFLATE_COLOR = "#ff0066";
const ACTIVE_COLOR = "#007fff";
const FALLBACK_IMAGE_ACTIVE = "https://factoryplaystorage.blob.core.windows.net/files/product_default.JPG";
const FALLBACK_IMAGE_INFLATE = "https://factoryplaystorage.blob.core.windows.net/files/inflate_default.JPG";

export default {
  components: {VueperSlides, VueperSlide },
  data: function () {
    return {
        url: process.env.VUE_APP_URL_ROOT,
        baseUrl: process.env.VUE_APP_FRONT,
        quantity: 1,
        hover: false,
        dynamicHeight: null,
        slide: 0,
        INFLATE: INFLATE,
        INFLATE_COLOR: INFLATE_COLOR,
        ACTIVE_COLOR: ACTIVE_COLOR,
        FALLBACK_IMAGE_ACTIVE: FALLBACK_IMAGE_ACTIVE,
        FALLBACK_IMAGE_INFLATE: FALLBACK_IMAGE_INFLATE
    };
  },
  props: {
    brand: null, // INFLATE, ACTIVE
    products: Array,
    title: String,
    autoplayState: Boolean,
  },
  computed:{
    img: function()
      {
          return this.brand == INFLATE ? 'homeArrowInflate.svg' : 'homeArrowActive.svg';
      },
    fallbackImage() {
      return this.brand === INFLATE ? this.FALLBACK_IMAGE_INFLATE : this.FALLBACK_IMAGE_ACTIVE;
    },
  },
  methods: {
    ...mapActions('carts', ['addCart']),
    sendClick(index){
        this.$router.push({name: "ProductDetails", params: {product: this.products[index], slug: this.products[index].slug}}); 
    },
    slideChanged: function(val)
    {
      this.slide = val.currentSlide.index;
    },
    getFullUrl: function(index)
    {
      return `${this.baseUrl}/Product/${this.products[index].slug}`;
    },
  },
}
</script>

<style scoped>
a{
    text-decoration: none;
}
.boxes-container{
  height: 300px;
  flex-wrap: wrap;
}
.box{
  width: 100%;
}
.img-settings{
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Hover tile effect to match HeroGrid */
.tile{
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #0d0d0d;
  box-shadow: 0 2px 18px rgba(0,0,0,0.08);
  transition: transform .25s ease, box-shadow .25s ease;
}
.tile-img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform .6s cubic-bezier(.2,.6,.2,1);
}
.tile-gradient{
  position: absolute;
  left: 0; right: 0; bottom: 0;
  height: 40%;
  background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,.55) 100%);
}
.tile-meta{
  position: absolute;
  left: 12px; right: 12px; bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: white;
}
.meta-left{ min-width: 0; }
.meta-title{
  font-weight: 600;
  font-size: 14px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.meta-right{ display: flex; align-items: center; gap: 8px; }
.cta{
  background: white;
  color: #111;
  border-radius: 999px;
  font-size: 12px;
  padding: 6px 10px;
}
/* Hover within our component */
.tile:hover{ box-shadow: 0 16px 32px rgba(0,0,0,0.18); }
.tile:hover .tile-img{ transform: scale(1.05); }

/* Ensure hover also works when hovering slide container (vueper) */
::v-deep .vueperslide:hover .tile { box-shadow: 0 16px 32px rgba(0,0,0,0.18); }
::v-deep .vueperslide:hover .tile-img { transform: scale(1.05); }

#product-text{
  background-color:#17224d;
}
.title-style{
  color: white;
  font-size: 15px;
  position: absolute;
  bottom: -55px;
  z-index: 3;
  left: 10px;
}
.container-style{
  position: relative;
}
.div-title{
  position: relative;
}
.img-style{
  position: absolute;
  width: 135px;
  z-index: 2;
  height: 50px;
  top: 20px;
}
</style>